<template>
  <a-modal title="配方原料对比" width="960px" :visible="visible" :forceRender="true" :destroyOnClose="true" @cancel="cancel" @ok="cancel">
    <template slot="footer">
<!--      <a-button key="back" disabled style="position:absolute;left:20px">-->
<!--        导出-->
<!--      </a-button>-->
      <a-button v-if="mExport" key="export" type="primary" @click="exportToExcel" style="position:absolute;left:20px">
        导出数据
      </a-button>
      <a-button key="submit" type="primary" @click="cancel">
        关闭
      </a-button>
    </template>
    <div style="display:flex;">
      <div style="wordwrap:nowrap;display:block;width:100px">对比参数:</div>
      <a-checkbox-group v-model="checkedColumns">
        <a-col v-for="item in checkable" :key="item.dataIndex" :span="4">
          <a-checkbox :value="item" :checked="true">
            {{ item.title }}
          </a-checkbox>
        </a-col>
      </a-checkbox-group>
    </div>
    <a-table :row-key="record => record.id" :data-source="records" :loading="loading" :pagination="false" :scroll="{ y: 500 }" bordered>
      <a-table-column title="原料名称" data-index="title" align="center" :width="200"> </a-table-column>
      <a-table-column title="参数" data-index="prop" :width="100" align="center"> </a-table-column>
      <a-table-column data-index="col0" :width="240" align="center">
        <div slot="title" v-if="selectedAry[0]&&selectedAry[0].factoryName">
          <div>{{ selectedAry[0].factoryName }}</div>
          <div style="color: #1890ff">{{ selectedAry[0].formulaName }}</div>
        </div>
      </a-table-column>
      <a-table-column data-index="col1" align="center" :width="240">
        <div slot="title" v-if="selectedAry[1] && selectedAry[1].factoryName">
          <div>{{ selectedAry[1].factoryName }}</div>
          <div style="color: #1890ff">{{ selectedAry[1].formulaName }}</div>
        </div>
      </a-table-column>
      <a-table-column title="差异" align="center" :width="100" v-slot="scope">
        <div v-if="scope.col0 === scope.col1">-</div>
        <div v-else-if="isNaN(scope.col0) && isNaN(scope.col1)">-</div>
        <div v-else-if="(scope.col0 == 0.00) && (isNaN(scope.col1))">-</div>
        <div v-else-if="(scope.col1 == 0.00) && (isNaN(scope.col0))">-</div>
        <div v-else-if="!isNaN(scope.col0) && isNaN(scope.col1)" style="color:green">{{ `↓${scope.col0}` }}</div>
        <div v-else-if="isNaN(scope.col0) && !isNaN(scope.col1)" style="color:red">{{ `↑${scope.col1}` }}</div>
        <div v-else-if="scope.col0 - scope.col1 < 0" style="color:red">{{ `↑${(scope.col1 - scope.col0).toFixed(3)}` }}</div>
        <div v-else style="color:green">{{ `↓${(scope.col0 - scope.col1).toFixed(3)}` }}</div>
      </a-table-column>
    </a-table>
  </a-modal>
</template>
<script>
import { coreMixins } from '@/Utils/core'
import { modelMixins } from '@/components/Model/unitls.js'
import { columns } from '../config'
import * as XLSX from 'xlsx'
export default {
  mixins: [coreMixins, modelMixins],
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    ary: {
      type: Array,
      required: true,
      default: () => []
    },
    selectedAry: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      indeterminate: false,
      checkAll: true,
      checkable: columns.filter(item => item.checkable),
      checkedColumns: columns.filter(item => item.checked),
      mExport: false,
    }
  },
  computed: {
    records() {
      const obj = {}
      this.ary&&this.ary.forEach((item) => {
        if (!obj[item.rawName]) {
          obj[item.rawName] = [item.rawName]
        }
        //如果是工厂是列表是第一个就赋值第一个，是第二个就赋值第2个
        if (item.factoryName === this.selectedAry[0].factoryName
            && item.formulaName === this.selectedAry[0].formulaName
            && item.formulaCode	 === this.selectedAry[0].formulaCode) {
          obj[item.rawName][1] = item
        } else {
          obj[item.rawName][2] = item
        }
      })
      const result = Object.values(obj).map(([title, col0, col1]) => {
        const materials = []
        this.checkedColumns.forEach((item, i) => {
          const value0 = col0 ? col0[item.dataIndex] : null
          const value1 = col1 ? col1[item.dataIndex] : null
          materials.push({
            title: i == 0 ? title : '',
            prop: item.title,
            id: title + item.title,
            col0: value0 !== null && value0 !== undefined ? (value0.toFixed ? value0.toFixed(3) : value0) : '--',
            col1: value1 !== null && value1 !== undefined ? (value1.toFixed ? value1.toFixed(3) : value1) : '--',
            diff: ''
          })
        })
        return materials
      })
      return result.flat()
    }
  },
  watch: {
    checkedColumns(val) {
      this.indeterminate = !!val.length && val.length < this.checkable.length
      this.checkAll = val.length === this.checkable.length
    },
    ary() {
      this.checkedColumns = columns.filter(item => item.checked)
    }
  },
  mounted() {
    this.getBtn();
  },
  methods: {
    getBtn() {
      let factoryId = window.localStorage.getItem('factoryId');
      if (!factoryId) return;
      this.$http.get("/iot-system/menu/buttons", { params: { controlEnd: false, factoryId } }).then(res => {
        let { success, data } = res;
        if (success) {
          data && data.forEach(el => {
            if (el.path === '/fast/MaterialAnalyse') {
              el.children && el.children.forEach(item => {
                if (item.code === 'mExport') this.mExport = true;
              });
            }
          });
        }
      });
    },
    exportToExcel() {
      // 准备表头
      const headers = [
        { key: 'title', title: '原料名称' },
        { key: 'prop', title: '参数' },
        { key: 'col0', title: this.selectedAry[0]?.factoryName ?
              `${this.selectedAry[0].factoryName}-${this.selectedAry[0].formulaName}` : '配方1' },
        { key: 'col1', title: this.selectedAry[1]?.factoryName ?
              `${this.selectedAry[1].factoryName}-${this.selectedAry[1].formulaName}` : '配方2' },
        { key: 'diff', title: '差异' }
      ];

      // 处理数据
      const data = this.records.map(item => {
        // 计算差异值
        let diff = '-';
        if (item.col0 !== item.col1) {
          const val0 = parseFloat(item.col0);
          const val1 = parseFloat(item.col1);
          if (!isNaN(val0) && !isNaN(val1)) {
            if (val0 - val1 < 0) {
              diff = `↑${(val1 - val0).toFixed(3)}`;
            } else {
              diff = `↓${(val0 - val1).toFixed(3)}`;
            }
          }else if (isNaN(val0) && isNaN(val1)) {
            diff = '-';
          }else if(val0 == 0.00 && isNaN(val1)){
            diff = '-';
          }else if(val1 == 0.00 && isNaN(val0)){
            diff = '-';
          } else if (isNaN(val0) && !isNaN(val1)) {
            diff = `↑${(val1).toFixed(3)}`;
          }else if (!isNaN(val0) && isNaN(val1)) {
            diff = `↓${(val0).toFixed(3)}`;
          }
        }

        return {
          title: item.title,
          prop: item.prop,
          col0: item.col0,
          col1: item.col1,
          diff: diff
        };
      });

      // 创建工作表
      const worksheet = XLSX.utils.json_to_sheet(data, { header: headers.map(h => h.key) });

      // 设置表头显示名称
      headers.forEach((header, index) => {
        const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c: index })];
        if (cell) {
          cell.v = header.title;
        }
      });

      // 创建工作簿
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, '配方原料对比');

      // 导出文件
      XLSX.writeFile(workbook, '配方原料对比.xlsx');
    },
    onCheckAllChange(e) {
      Object.assign(this, {
        checkedColumns: e.target.checked ? this.checkable : [],
        indeterminate: false,
        checkAll: e.target.checked
      })
    },
    cancel() {
      this.$emit('update:visible', false)
    }
  }
}
</script>
